export const features = {
  footer: process.env.VUE_APP_ENABLE_FOOTER === 'true',
};
